import React from "react";
import { connect } from "react-redux";

import {
  mapStateToProps,
  mapDispatchToProps,
  ProjectContainer
} from "components/Project/ProjectContainer";
import { HOME } from "App/Routes";
import ProjectPage from "./ProjectPage";
import Loading from "components/shared/Loading";
import GenericErrorPage from "components/ErrorPages/GenericError/GenericErrorPage";

import { SINGLE_PROJECT_APP } from "config";
import sessionStorageService from "services/sessionStorageService";
import localize from "lang/localize";

/*
  In Project Container, this.props.id refers to category ID
  while this.props.projectId refers to projectId.
*/
export class LosDesafiosProjectContainer extends ProjectContainer {
  render() {
    const UNAVAILABLE_GAME_ERROR_LIST = [
      localize("unavailable_game_private", this.props.language),
      localize("unavailable_game_unpublished", this.props.language),
      localize("unavailable_game_deleted", this.props.language),
      localize("unavailable_game_no_topics", this.props.language),
      localize("unavailable_game_invalid", this.props.language)
    ];
    const UNAVAILABLE_GAME_ERROR_LIST_LOGGEDIN = [
      localize("unavailable_game_private_loggedin", this.props.language),
      localize("unavailable_game_unpublished", this.props.language),
      localize("unavailable_game_deleted", this.props.language),
      localize("unavailable_game_no_topics", this.props.language),
      localize("unavailable_game_invalid", this.props.language)
    ];
    const IS_EMBEDDED_PROJECT =
      sessionStorageService.getItem("embedded_project") === "true"
        ? true
        : false;

    if (
      this.state.topics &&
      (this.state.topics.length !== 0 || this.state.categories)
    ) {
      /*
        Setting a key prop for ProjectPage will allow the interface to be reset.
        This is evident in mobile Project view, where you will be directed back
        to the first slide. States are reset in componentDidUpdate().
      */
      return (
        <ProjectPage
          isLoadingMore={this.state.isLoadingMore}
          sessionKey={this.props.sessionKey}
          ref={projectPage => (this.projectPage = projectPage)}
          key={this.props.projectId}
          projectId={this.props.projectId}
          id={this.props.id}
          project={this.state.project}
          projectImage={this.state.project.bannerImage}
          buttons={this.props.buttons}
          categories={this.state.categories}
          topics={this.state.topics}
          more={this.state.more}
          showcaseProject={this.state.showcaseProject}
          popup={this.state.popup}
          showPopup={this.state.showPopup}
          handleClosePopupAlertDialog={this.handleClosePopupAlertDialog}
          showShareGameDialog={this.state.showShareGameDialog}
          handleOpenShareGameDialog={this.handleOpenShareGameDialog}
          handleCloseShareGameDialog={this.handleCloseShareGameDialog}
          handleMore={() => this.handleMore()}
          user={this.props.user}
          team={this.props.team}
          notifications={this.props.notifications || 0}
          inboxUnread={this.props.inboxUnread || 0}
          language={this.props.language}
          handleKeyPress={this.handleKeyPress}
          handleSearchChange={this.handleSearchChange}
          handleSubmit={event => {
            this.handleSubmit(event);
          }}
        />
      );
    } else if (this.state.topics && !this.props.sessionKey) {
      /* No information is returned, but not logged in */
      return (
        <GenericErrorPage
          routeUrl={this.getLoginRoute()}
          routeName={localize("button_login", this.props.language)}
          message={localize("unavailable_game_long", this.props.language)}
          messageList={UNAVAILABLE_GAME_ERROR_LIST}
          endMessage={localize(
            "unavailable_game_login_prompt",
            this.props.language
          )}
          isBackRoute={false}
          language={this.props.language}
        />
      );
    } else if (this.state.topics) {
      /* No information is returned, but logged in */
      return (
        <GenericErrorPage
          routeUrl={SINGLE_PROJECT_APP || IS_EMBEDDED_PROJECT ? null : HOME}
          routeName={localize("icon_home", this.props.language)}
          message={localize("unavailable_game_long", this.props.language)}
          messageList={UNAVAILABLE_GAME_ERROR_LIST_LOGGEDIN}
          language={this.props.language}
        />
      ); // no topics/doesnt exist
    } else {
      return <Loading />;
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LosDesafiosProjectContainer);
